// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { v1 as uuidV1 } from 'uuid';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';

@Component({
  selector: 'lbca-input-radio',
  templateUrl: './input-radio.component.html',
  styleUrl: './input-radio.component.scss',
  imports: [IconComponent],
})
export class InputRadioComponent {
  private errorPopup!: ErrorOverlayClass;

  public options: any[] = [];
  public hasError: boolean = false;
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isReadOnly: boolean = false;
  public setDanger: boolean = false;

  public labelValue: string = '';
  public helperTextValue: string = '';

  public valueSelected: any = '';

  public inlineFields = false;

  public elementId = uuidV1();
  private _fieldMetadata: any;

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );
  }

  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;

  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set readOnly(readOnly: boolean) {
    this.isReadOnly = readOnly;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set dangerNegativeOpt(value: boolean) {
    this.setDanger = value;
  }
  @Input() set hasExternalError(value: boolean) {
    this.hasError = value;
  }

  @Input() autoSelect: boolean = false;
  @Input() autoSelectLen: number = 1;
  @Input() autoSelectIndex: number = 0;

  @Input('options') set optionsList(val) {
    if (!val) return;
    const checkBoolean =
      val.length === 2
        ? val.filter(
            (itemValue) => String(itemValue.id) === 'false' || String(itemValue.id) === 'true'
          ).length === val.length
        : false;
    const valSorted = val.sort((a, b) => a.label.localeCompare(b.label));
    this.options = checkBoolean ? valSorted.reverse() : valSorted;

    if (this.autoSelect) {
      this.selectOption(null, this.options[0], null as any);
    }
    // AUTO SELECT PARA CAMPOS COM UMA UNICA OPÇÃO
    // setTimeout(() => {
    //   if (this.options.length === this.autoSelectLen) {
    //     this.selectOption(null, this.options[this.autoSelectIndex], true);
    //   }
    // }, 400);
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      // reset Error
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set inline(val) {
    this.inlineFields = val;
  }

  @Input()
  set value(value) {
    if (value !== undefined && value !== null && value !== '') {
      this.valueSelected = value;
      this.selectOption(null, { id: value }, true);
    }
  }

  @Input() set fieldMetadata(value: any) {
    this._fieldMetadata = value;
  }

  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('startValue') startValueEmmiter = new EventEmitter();
  @Output('changeLabelValue') changeLabelEmmiter = new EventEmitter();
  @Output() focusState = new EventEmitter();
  @Output('validState') setValidEmitter = new EventEmitter();
  @Output('setError') setErrorEmmiter = new EventEmitter();

  public selectOption($event, option, start: boolean = false): void {
    this.valueSelected = this.convertStringBooleanToBoolean(option.id);

    if (this.valueSelected !== '') {
      // if (!start)
      this.changeEmmiter.emit(this.valueSelected);
    }
    if (option.label) this.changeLabelEmmiter.emit(option.label);
    this.focusState.emit(false);
    // Retira o erro de campo obrigatório (e consequentemente todos os erros desse field).
    this.setErrorEmmiter.emit([]);
    this.setValidEmitter.emit(true);
  }

  convertStringBooleanToBoolean(value: string) {
    if (typeof value === 'boolean') {
      return value;
    }
    return String(value);
  }

  isChecked(value: any) {
    if (
      typeof this.valueSelected !== 'undefined' &&
      this.convertStringBooleanToBoolean(this.valueSelected) ===
        this.convertStringBooleanToBoolean(value)
    ) {
      return 'checked';
    } else {
      return '';
    }
  }

  public mouseenter(): void {
    this.errorPopup.setFocus(true);
  }

  public mouseleave(): void {
    this.errorPopup.setFocus(false);
  }

  public getFocus(): void {
    this.mainElement.nativeElement.focus();
  }
}
